import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, IMPRESSION_ACTIONS } from "@cart-client/analytics/constants";
export const impressionCartStressComms = ({
    cartId = "",
    msg = "",
    impressionEvent,
}: {
    cartId?: string;
    msg?: string;
    impressionEvent: AnalyticsContextValue["impressionEvent"];
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_STRESS_COMM,
        label: cartId,
        context: JSON.stringify({ msg }),
    });
};
